import './BenefitsCoupons2.scss';
import useWindowSize from '../../assets/customHooks/useWindowSize';
import useHandleAnchorClick from '../../hooks/useHandleAnchorClick';
import { useTranslation } from 'react-i18next';

interface Incentatives{
  description:string;
  table:string;
}

const BenefitsCoupons = () => {
  const {t} = useTranslation();
  const incentative = t('benefits_coupon_incentive',{ returnObjects: true, defaultValue: []})[0] as Incentatives;
  const size = useWindowSize();
  const isMobile = size.width! < 900;
  const handleAnchorClick = useHandleAnchorClick();
  const mobileTable = (table) => {
    if (size?.width! > 900) return table;

    const parser = new DOMParser();
    const doc = parser.parseFromString(table, 'text/html');
    const innerTables = doc.querySelectorAll('.innerTable');

    innerTables.forEach((table) => {
      const countries = Array.from(table.querySelectorAll('td')).map(
        (td) => td.textContent
      );
      table.innerHTML = `<tbody>${countries
        .map((country) => `<tr><td>${country}</td></tr>`)
        .join('')}</tbody>`;
    });

    return doc.body.innerHTML;
  };

  return (
    <div className="coupon-incentive" aria-labelledby="coupon-incentive-id">
      {/* <article className="coupon-incentive-left">
				<h2 id="coupon-incentive-id">{data.title}</h2>
				<p>{data.paragraph1}</p>
				<p>{data.paragraph2}</p>
				<p><i>{data.paragraph3}</i></p>
				{!isMobile && (
					<img
						className="coupon-incentive-icon"
						src={process.env.PUBLIC_URL + data.image}
						alt="header"
						aria-hidden={true}
					/>
				)}
			</article> */}
      <div className="coupon-incentive-left">
        {incentative && (
        <div
          dangerouslySetInnerHTML={{
            __html: incentative.description
          }}
        ></div>
        )}
        {!isMobile && (
          <img
            className="coupon-incentive-icon"
            src={
              process.env.PUBLIC_URL +
              t('ndc-program.benefits.section.coupon.image')
            }
            alt="header"
            aria-hidden={true}
          />
        )}
      </div>
      <div
        className="coupon-incentive-right"
        dangerouslySetInnerHTML={{
          __html:incentative ? mobileTable(incentative.table) : ''
        }}
        onClick={handleAnchorClick}
      ></div>
			<div>
      {isMobile && (
        <img
          className="coupon-incentive-icon"
					src={
						process.env.PUBLIC_URL +
						t('ndc-program.benefits.section.coupon.image')
					}
          alt="header"
        />
      )}
			</div>
    </div>
  );
};

export default BenefitsCoupons;
